import { render, staticRenderFns } from "./Bottle.vue?vue&type=template&id=71132404&scoped=true&"
import script from "./Bottle.vue?vue&type=script&lang=js&"
export * from "./Bottle.vue?vue&type=script&lang=js&"
import style0 from "./Bottle.vue?vue&type=style&index=0&id=71132404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71132404",
  null
  
)

export default component.exports